<div
  class="flex--justify-space-between flex--align-center spacing--margin-horizontal spacing--margin-top mat-button-row screen-only"
>
  <button
    mat-flat-button
    color="accent"
    data-test="feed-advice-detail__print"
    (click)="printFinalSetup()"
  >
    <mat-icon>print</mat-icon>{{ 'feed-advice.create.print' | translate }}
  </button>
  <div *ngIf="totalsPrint$ | async as total">
    {{ 'total' | translate }} (€): {{ total.amountIncludingVat | agrNumber: '1.2-2' }}
  </div>
</div>

<div
  class="spacing--margin-horizontal spacing--margin-bottom screen-only"
  *ngIf="(isLoading$ | async) === false"
>
  <agr-summary-card
    [title]="'final-setup.fixed-price' | translate"
    [actions]="summaryCardActions"
    [canExpand]="false"
    [isExpanded]="toggleValueFixedPrice"
    class="spacing--margin-bottom"
  >
    <ng-container customActions>
      <mat-slide-toggle
        [hideIcon]="true"
        data-test="cycle-overview__fixedPriceFinalSetup"
        color="primary"
        [(ngModel)]="toggleValueFixedPrice"
      >
      </mat-slide-toggle>
    </ng-container>
    <form [formGroup]="fixedPriceFormGroup" class="flex--row flex--align-center column-gap">
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>{{ 'invoice-date' | translate }}</mat-label>
        <input
          matInput
          formControlName="invoiceDate"
          [matDatepicker]="invoiceDatePicker"
          placeholder="{{ 'invoice-date' | translate }}"
        />
        <mat-datepicker-toggle matIconSuffix [for]="invoiceDatePicker"></mat-datepicker-toggle>
        <mat-datepicker touchUi #invoiceDatePicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field subscriptSizing="dynamic">
        <mat-label>{{ 'invoice-number' | translate }}</mat-label>
        <input
          matInput
          formControlName="invoiceNumber"
          placeholder="{{ 'invoice-number' | translate }}"
        />
      </mat-form-field>

      <mat-form-field subscriptSizing="dynamic">
        <mat-label>{{ 'final-setup.fixed-price-per-100' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          [step]="0.001"
          [enableStepArrows]="false"
          formControlName="pricePer100Kg"
          placeholder="{{ 'final-setup.fixed-price-per-100' | translate }}"
        />
      </mat-form-field>

      <mat-form-field subscriptSizing="dynamic">
        <mat-label>{{ 'vat-percentage' | translate }}</mat-label>
        <span matTextSuffix>%</span>
        <mat-select [hideSingleSelectionIndicator]="true" formControlName="vatPercentage">
          <mat-option [value]="null"></mat-option>
          <mat-option *ngFor="let vatPercentage of vatPercentages" [value]="vatPercentage">
            {{ vatPercentage }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </form>
  </agr-summary-card>

  <agr-summary-card
    [title]="'final-setup.chick-deliveries' | translate"
    [canExpand]="false"
    [actions]="summaryCardActions"
    [isExpanded]="toggleValueChickDeliveries"
    class="spacing--margin-all"
  >
    <ng-container customActions>
      <mat-slide-toggle
        [hideIcon]="true"
        data-test="cycle-overview__chickDeliveriesFinalSetup"
        color="primary"
        [(ngModel)]="toggleValueChickDeliveries"
        (change)="updateFinalSetup()"
      >
      </mat-slide-toggle>
    </ng-container>

    <agr-table
      [config]="chickDeliveriesTableConfig"
      [emptyTitle]="'final-setup.empty-chick-deliveries-title' | translate"
      [emptyDescription]="'final-setup.empty-chick-deliveries-description' | translate"
      [emptyImage]="isAgrifirm ? 'assets/images/delivery.jpg' : ''"
    ></agr-table>
  </agr-summary-card>

  <agr-summary-card
    [title]="'final-setup.feed-deliveries' | translate"
    [canExpand]="false"
    [actions]="summaryCardActions"
    class="spacing--margin-all"
  >
    <ng-container customActions>
      <div style="font-size: 14px">
        <mat-form-field style="margin: 0 16px -1.25em">
          <mat-label>{{ 'final-setup.feed-delivery-end-date' | translate }}</mat-label>
          <input
            matInput
            [formControl]="feedDeliveryEndDateControl"
            [matDatepicker]="datePicker"
            placeholder="{{ 'final-setup.feed-delivery-end-date' | translate }}"
          />
          <mat-datepicker-toggle matIconSuffix [for]="datePicker"></mat-datepicker-toggle>
          <mat-datepicker touchUi #datePicker></mat-datepicker>
        </mat-form-field>

        <mat-slide-toggle
          [hideIcon]="true"
          data-test="cycle-overview__feedDeliveriesFinalSetup"
          color="primary"
          [(ngModel)]="toggleIncludeInCalculationsFeedDeliveries"
          (change)="updateFinalSetup()"
          labelPosition="before"
          class="text--small"
        >
          {{ 'final-setup.include-in-calculations-label' | translate }}
        </mat-slide-toggle>
      </div>
    </ng-container>

    <agr-table
      [config]="feedDeliveriesTableConfig"
      [emptyTitle]="'final-setup.empty-feed-deliveries-title' | translate"
      [emptyDescription]="'final-setup.empty-feed-deliveries-description' | translate"
      [emptyImage]="isAgrifirm ? 'assets/images/delivery.jpg' : ''"
    ></agr-table>
  </agr-summary-card>

  <agr-summary-card
    [title]="'final-setup.departures' | translate"
    [canExpand]="false"
    [actions]="summaryCardActions"
    [isExpanded]="toggleValueDepartures"
    class="spacing--margin-all"
  >
    <ng-container customActions *ngIf="unlinkedSlaughterInvoices$ | async as unlinked">
      <button
        mat-flat-button
        color="primary"
        (click)="openImportDialog()"
        data-test="departure__import"
        class="spacing--margin-right"
        [disabled]="unlinked.length === 0"
      >
        <mat-icon>import_export</mat-icon>{{ 'import' | translate }} ({{ unlinked.length }})
      </button>

      <mat-slide-toggle
        [hideIcon]="true"
        data-test="cycle-overview__departuresFinalSetup"
        color="primary"
        [(ngModel)]="toggleValueDepartures"
        (change)="updateFinalSetup()"
      >
      </mat-slide-toggle>
    </ng-container>

    <agr-table
      [config]="departuresTableConfig"
      [emptyTitle]="'final-setup.empty-departures-title' | translate"
      [emptyDescription]="'final-setup.empty-departures-description' | translate"
      [emptyImage]="isAgrifirm ? 'assets/images/delivery.jpg' : ''"
    ></agr-table>
  </agr-summary-card>

  <agr-summary-card
    [title]="'final-setup.discounts' | translate"
    [canExpand]="false"
    [actions]="summaryCardActions"
    [isExpanded]="toggleValueDiscounts"
    class="spacing--margin-all"
  >
    <ng-container customActions>
      <mat-slide-toggle
        [hideIcon]="true"
        data-test="cycle-overview__chickDiscountsFinalSetup"
        color="primary"
        [(ngModel)]="toggleValueDiscounts"
        (change)="updateFinalSetup()"
      >
      </mat-slide-toggle>
    </ng-container>

    <agr-table
      [config]="discountsTableConfig"
      [emptyTitle]="'final-setup.empty-discounts-title' | translate"
      [emptyDescription]="'final-setup.empty-discounts-description' | translate"
      emptyImage="assets/images/arrival.jpg"
    ></agr-table>
  </agr-summary-card>

  <agr-summary-card
    [title]="'final-setup.additional-invoices' | translate"
    [canExpand]="false"
    [actions]="summaryCardActions"
  >
    <ng-container customActions>
      <button
        mat-flat-button
        color="primary"
        (click)="addAdditionalInvoice()"
        data-test="additionalInvoices__add"
      >
        <mat-icon>add</mat-icon>{{ 'final-setup.additional-invoices-add' | translate }}
      </button>
    </ng-container>

    <agr-table
      [config]="additionalInvoicesTableConfig"
      [emptyTitle]="'final-setup.empty-additional-invoices-title' | translate"
      [emptyDescription]="'final-setup.empty-additional-invoices-description' | translate"
      emptyImage="assets/images/arrival.jpg"
    ></agr-table>
  </agr-summary-card>
</div>

<app-final-setup-print
  [feedDeliveriesAggregate$]="
    toggleIncludeInCalculationsFeedDeliveries ? feedDeliveriesAggregatePrint$ : null
  "
  [feedDeliveries$]="feedDeliveriesPrint$"
  [feedDeliveriesTotal$]="feedDeliveriesTotalPrint$"
  [discounts$]="toggleValueDiscounts ? discountsPrint$ : null"
  [chickDeliveries$]="toggleValueChickDeliveries ? chickDeliveriesPrint$ : null"
  [departures$]="toggleValueDepartures ? departuresPrint$ : null"
  [totalsExcludingDepartures$]="totalsExcludingDeparturesPrint$"
  [totals$]="totalsPrint$"
  [showTotalsExcludingDepartures$]="showTotalsExcludingDepartures$"
  [additionalInvoices$]="additionalInvoicesPrint$"
  [additionalInvoicesTotal$]="additionalInvoicesTotalPrint$"
  [fixedPriceCorrection$]="
    toggleIncludeInCalculationsFeedDeliveries ? fixedPriceCorrectionPrint$ : null
  "
>
</app-final-setup-print>
